import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Button from '@material-ui/core/Button';
import SubscriptionModel from '../../../../models/subscription';
import PackageModel from '../../../../models/package';
import SubscriptionInfoViewComponent from './subscription-info-view';
import SubscriptionPaymentComponent from './subscription-payment';
import { lzCallApi } from '../../../../services/LzApiService';
import { lzGetFormattedAmount } from '../../../../services/LzUtils';
import { lzGetFormattedDate } from '../../../../services/LzMoment';

class SubscriptionStatusComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            subscription: null,
            packages: [],
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        this.setState({ loading: true });

        // Make the api call and get the data
        const data = await lzCallApi('subscription/status');

        // Load data if call was successful
        if (data) {
            this.setState({
                subscription: data.subscription ? new SubscriptionModel(data.subscription) : null,
                packages: PackageModel.parseArray(data.packages),
                loading: false,
            });
        } else {
            this.setState({ loading: false });
        }
    }

    async subscribe(packageId, term) {
        this.setState({ loading: true });

        const data = await lzCallApi('subscription/select', {
            package_id: packageId,
            term: term,
        });

        if (data) {
            this.setState({
                subscription: data.subscription ? new SubscriptionModel(data.subscription) : null,
                loading: false,
            });
        } else {
            this.setState({ loading: false });
        }
    }

    async requestCancellation() {
        if (!window.confirm('Are you sure you want to cancel your subscription?')) {
            return;
        }

        this.setState({ loading: true });

        const data = await lzCallApi('subscription/cancel');

        if (data) {
            this.load();
        } else {
            this.setState({ loading: false });
        }
    }

    render() {
        const { subscription, packages, loading } = this.state;
        const { inlineWidget } = this.props;

        return (
            <div className={inlineWidget ? 'lz-inline-widget' : ''}>

                {!loading &&
                    <React.Fragment>

                        {subscription ?
                            <div>
                                {subscription.status === SubscriptionModel.STATUS_CREATED &&
                                    <React.Fragment>
                                        <Alert variant="filled" severity="warning">
                                            <AlertTitle>Your subscription needs payment!</AlertTitle>
                                            Please select a payment option below to activate the subscription...
                                        </Alert>
                                        <SubscriptionInfoViewComponent subscription={subscription} />
                                        <SubscriptionPaymentComponent subscription={subscription} onReload={() => this.load()} />
                                    </React.Fragment>
                                }
                                {subscription.status === SubscriptionModel.STATUS_PAYMENT_DONE &&
                                    <React.Fragment>
                                        <Alert variant="filled" severity="success">
                                            <AlertTitle>Your subscription payment is done!</AlertTitle>
                                            The subscription will be active through {lzGetFormattedDate(subscription.started_at)} to {lzGetFormattedDate(subscription.ended_at)}...
                                        </Alert>
                                        <SubscriptionInfoViewComponent subscription={subscription} />
                                        <SubscriptionPaymentComponent subscription={subscription} viewOnly onRequestCancellation={() => this.requestCancellation()} />
                                    </React.Fragment>
                                }
                                {subscription.status === SubscriptionModel.STATUS_PAYMENT_FAILED &&
                                    <React.Fragment>
                                        <Alert variant="filled" severity="error">
                                            <AlertTitle>Your subscription payment has failed!</AlertTitle>
                                            Please check the payment logs or contact our support for further assistance...
                                        </Alert>
                                        <SubscriptionInfoViewComponent subscription={subscription} />
                                        <SubscriptionPaymentComponent subscription={subscription} onReload={() => this.load()} />
                                    </React.Fragment>
                                }
                                {subscription.status === SubscriptionModel.STATUS_ACTIVE &&
                                    <React.Fragment>
                                        <Alert variant="filled" severity="success">
                                            <AlertTitle>Your subscription is Active!</AlertTitle>
                                            Your subscription is active through {lzGetFormattedDate(subscription.started_at)} to {lzGetFormattedDate(subscription.ended_at)}...
                                        </Alert>
                                        <SubscriptionInfoViewComponent subscription={subscription} />
                                        <SubscriptionPaymentComponent subscription={subscription} viewOnly onRequestCancellation={() => this.requestCancellation()} />
                                    </React.Fragment>
                                }
                                {subscription.status === SubscriptionModel.STATUS_EXPIRED &&
                                    <React.Fragment>
                                        <Alert variant="filled" severity="error">
                                            <AlertTitle>Your subscription has expired!</AlertTitle>
                                            Please select an option below to subscribe and start using our services...
                                        </Alert>
                                        <SubscriptionInfoViewComponent subscription={subscription} />
                                        <SubscriptionPaymentComponent subscription={subscription} onReload={() => this.load()} />
                                    </React.Fragment>
                                }
                                {subscription.status === SubscriptionModel.STATUS_CANCELLED &&
                                    <React.Fragment>
                                        <Alert variant="filled" severity="error">
                                            <AlertTitle>Your subscription was cancelled!</AlertTitle>
                                            Please select an option below to subscribe again...
                                        </Alert>
                                        <SubscriptionInfoViewComponent subscription={subscription} />
                                        <SubscriptionPaymentComponent subscription={subscription} onReload={() => this.load()} />
                                    </React.Fragment>
                                }
                                {subscription.status === SubscriptionModel.STATUS_REFUNDED &&
                                    <React.Fragment>
                                        <Alert variant="filled" severity="error">
                                            <AlertTitle>Your subscription was refunded!</AlertTitle>
                                            Please select an option below to subscribe again...
                                        </Alert>
                                        <SubscriptionInfoViewComponent subscription={subscription} />
                                        <SubscriptionPaymentComponent subscription={subscription} onReload={() => this.load()} />
                                    </React.Fragment>
                                }
                            </div>
                            :
                            <div>
                                <Alert variant="filled" severity="error">
                                    <AlertTitle>You have not subscribed to any plan!</AlertTitle>
                                    Please select an option below to subscribe and start using our services...
                                </Alert>
                            </div>
                        }

                        {(packages && !subscription) &&
                            <React.Fragment>
                                {packages.length > 1 ?
                                    <div>
                                        <div className="packages">
                                            {packages.map((pkg, dex) =>
                                                <React.Fragment key={'pkg-' + dex}>
                                                    <div className="package">
                                                        <Typography variant="h5">{pkg.name} Plan</Typography>
                                                        <Typography variant="h4">{lzGetFormattedAmount(pkg.price_per_month)} <small>/ per month</small></Typography>
                                                        <Typography variant="overline">{pkg.summary}</Typography>
                                                        <Button type="button" variant="contained" color="secondary" onClick={() => this.subscribe(pkg.id, 30)}>Subscribe!</Button>
                                                    </div>
                                                    {pkg.price_per_year > 0 &&
                                                        <div className="package">
                                                            <Typography variant="h5">{pkg.name} Plan</Typography>
                                                            <Typography variant="h4">{lzGetFormattedAmount(pkg.price_per_year)} <small>/ per year</small></Typography>
                                                            <Typography variant="overline">{pkg.summary}</Typography>
                                                            <Button type="button" variant="contained" color="secondary" onClick={() => this.subscribe(pkg.id, 365)}>Subscribe!</Button>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div className="packages">
                                            {packages.map((pkg, dex) =>
                                                <React.Fragment>
                                                    <div key={'pkg-' + dex} className="package">
                                                        <Typography variant="h5">{pkg.name} Plan</Typography>
                                                        <Typography variant="h4">{lzGetFormattedAmount(pkg.price_per_month, true, false, true)} <small>monthly</small></Typography>
                                                        <Typography variant="overline">{pkg.summary}</Typography>
                                                        <Button type="button" variant="contained" color="secondary" onClick={() => this.subscribe(pkg.id, 30)}>Subscribe!</Button>
                                                    </div>
                                                    {pkg.price_per_year > 0 &&
                                                        <div key={'pkg-' + dex} className="package">
                                                            <Typography variant="h5">{pkg.name} Plan</Typography>
                                                            <Typography variant="h3">
                                                                <small>Pay Anually and <span>Save 15%</span></small>
                                                                <strong>
                                                                    <small>{lzGetFormattedAmount(pkg.price_per_month * 12, true, false, true)}</small>
                                                                    &nbsp;{lzGetFormattedAmount(pkg.price_per_year, true, false, true)}
                                                                    <sub>anually</sub>
                                                                </strong>
                                                            </Typography>
                                                            <Typography variant="overline">{pkg.summary}</Typography>
                                                            <Button type="button" variant="contained" color="secondary" onClick={() => this.subscribe(pkg.id, 365)}>Subscribe!</Button>
                                                        </div>
                                                    }
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        }

                    </React.Fragment>
                }

            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        loading: state.commons.loading,
    }
};

export default connect(
    mapStateToProps
)(SubscriptionStatusComponent);
